import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Card } from '@tcc/crate';

// requesters
import { fetchCropProtectionProducts } from '../products';

// constants
import { experimentChemicalIds } from '../constants/activities';

// selectors
import {
  getExperimentApplication,
  getExperimentApplicationDate,
  getExperimentApplicationType,
  getExperimentScriptName
} from './selectors';
import { getApplicationProductsByChemicalTypeUuid } from 'products/selectors';

// actions
import {
  setApplicationTypeForExperiment,
  setSelectedProductForExperiment,
  updateExperimentApplicationDate
} from '../experiment';

// components
import CropProtectionSelection from './CropProtectionSelection';
import PlannedApplicationDate from './PlannedApplicationDate';
import ExperimentScriptName from './ExperimentScriptName';

const ExperimentPlanContainer = ({
  applicationType,
  fetchFertilizerProducts,
  onSelectApplicationType,
  onSetApplication,
  onSetExperimentApplicationDate,
  products,
  scriptName,
  selectedDate,
  selectedProduct
}) => {
  useEffect(() => {
    fetchFertilizerProducts(experimentChemicalIds);
  }, []);
  const cropProtections = Object.keys(experimentChemicalIds).map(chemType => ({
    chemType,
    products: products[experimentChemicalIds[chemType]] || []
  }));

  return (
    <Card className="experiment-plan-container">
      <PlannedApplicationDate
        onSelectDate={onSetExperimentApplicationDate}
        selectedDate={selectedDate}
      />
      <CropProtectionSelection
        applicationType={applicationType}
        cropProtectionTypes={experimentChemicalIds}
        cropProtections={cropProtections}
        onSelectApplicationType={onSelectApplicationType}
        onSetApplication={onSetApplication}
        selectedProduct={selectedProduct}
      />
      <ExperimentScriptName
        scriptName={scriptName}
      />
    </Card>
  );
};

ExperimentPlanContainer.propTypes = {
  applicationType: propTypes.string,
  fetchFertilizerProducts: propTypes.func,
  onSelectApplicationType: propTypes.func,
  onSetApplication: propTypes.func,
  onSetExperimentApplicationDate: propTypes.func,
  products: propTypes.array,
  scriptName: propTypes.string,
  selectedDate: propTypes.string,
  selectedProduct: propTypes.object
};

export default connect(
  (state) => ({
    applicationType: getExperimentApplicationType(state),
    products: getApplicationProductsByChemicalTypeUuid(state),
    scriptName: getExperimentScriptName(state),
    selectedDate: getExperimentApplicationDate(state),
    selectedProduct: getExperimentApplication(state)
  }), dispatch => ({
    fetchFertilizerProducts: (chemicalTypeIds) => {
      dispatch(fetchCropProtectionProducts({
        chemicalTypeIds
      }));
    },
    onSelectApplicationType: (applicationType) => {
      dispatch(setApplicationTypeForExperiment(applicationType));
    },
    onSetApplication: (selectedProductName, selectedProductId) => {
      dispatch(setSelectedProductForExperiment({
        name: selectedProductName, id: selectedProductId
      }));
    },
    onSetExperimentApplicationDate: (date) => {
      dispatch(
        updateExperimentApplicationDate(
          moment(date).format('YYYY-MM-DD') + moment(date).format('THH:mm:ss.SSS') + 'Z'
        )
      );
    }
  })
)(ExperimentPlanContainer);